export default __webpack_public_path__ + "static/media/profile-user.78b64d9f.svg";